
@if (!customizableMode) {
  <p-card>
    <div  class="padding15">
      <div style="position:relative">
        @if (!ps.hasAnyRole(['ROLE_TRADER'])) {
<div style="
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  width: 100%;
                  opacity: 0.5;
                  background-color: white;
                  height: 100%;">
          </div>
        }

        <div class="module-title">
          <div class="module-title-label" >Blotter Summary</div>
          <div [routerLink]="['/orders/order-blotter']" style="cursor:pointer"><img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg"></div>
        </div>

        @if (!data) {
          <div class='loading-spinner'></div>
        }
        @if (data) {
          <div class="module-div-includes-charts">
            <div class="module-div-chart-wrap">
              <p-chart type="doughnut" [data]="chartData" [options]="options" width="176px" height="176px"></p-chart>
              <div class="module-chart-center">
                <div class="module-chart-center-number">{{data.activeBlotterTradesCount}}</div>
                <div class="label">Active Trades</div>
              </div>
            </div>
            <div class="blotter-details-panels">
              <div>
                <span class="blotter-details-panel">Requires Attention</span>
                <img class="svg-arrow-right-circle" (click)="showRequiresAttention()" src="../../assets/images/arrow-right-circle-outline.svg">
                <div class="blotter-details-panel-color-number modules-panel-number" [style.color]="colors[0]">{{data.requiresAttentionCount}}</div>
              </div>
              <div>
                <span class="blotter-details-panel">Pending</span>
                <img class="svg-arrow-right-circle" (click)="showPending()" src="../../assets/images/arrow-right-circle-outline.svg">
                <div class="blotter-details-panel-color-number modules-panel-number" [style.color]="colors[1]">{{data.pendingCount}}</div>
              </div>
              <div>
                <span class="blotter-details-panel">Filled</span>
                <img class="svg-arrow-right-circle" (click)="showFilled()" src="../../assets/images/arrow-right-circle-outline.svg">
                <div class="blotter-details-panel-color-number modules-panel-number" [style.color]="colors[2]">{{data.filledCount}}</div>
              </div>

            </div>
          </div>
        }
      </div>
    </div>
  </p-card>
}
@if (customizableMode) {
  <div style="display: flex;flex-direction: row;height: 100%;align-items: center;padding-bottom: 15px;">
    <div style="height:176px;width: 176px;margin-left: 10px;">
      <img src="../../assets/images/donut-skeleton.svg" style="cursor: inherit!important;">
    </div>
    <div style="margin-left: 30px;width:60%;">
      <div style="display: flex;flex-direction: row;">
        <div class="skeleton-styles-rectangle" style="width:65%;"></div>
        <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
      </div>
      <div class="skeleton-styles-rectangle" style="width:25%; margin-top: 5px;"></div>

      <div style="display: flex;flex-direction: row;margin-top: 10px;">
        <div class="skeleton-styles-rectangle" style="width:65%;"></div>
        <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
      </div>
      <div class="skeleton-styles-rectangle" style="width:25%;margin-top: 5px;"></div>

      <div style="display: flex;flex-direction: row;margin-top: 10px;">
        <div class="skeleton-styles-rectangle" style="width:65%;"></div>
        <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
      </div>
      <div class="skeleton-styles-rectangle" style="width:25%; margin-top: 5px;"></div>
    </div>
  </div>
}


